import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Tab } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import UserPane from './UserPane';
import LocationPane from './LocationPane';
import styles from './LeftPanelGrid.module.css';
// import { selectStop } from '../map/redux/actions';
import { closeView } from '../common/cardNavigationComponent/cardNavigationRedux';

const LeftPanelGrid = ({
  onUserSelect,
  clearSelectedUser,
  selectedUserIds,
  hideLocationsTab,
  selectedTaskTypeGroups,
  taskTypes,
}) => {
  const panes = [
    {
      menuItem: 'Resources',
      render: () => (
        <UserPane
          onUserSelect={onUserSelect}
          selectedUserIds={selectedUserIds}
          selectedTaskTypeGroups={selectedTaskTypeGroups}
          taskTypes={taskTypes}
        />
      ),
    },
    {
      menuItem: 'Locations',
      render: () => <LocationPane clearSelectedUser={clearSelectedUser} />,
    },
  ];

  const [activeIndex, handleActiveIndex] = useState(0);

  const dispatch = useDispatch();
  const resetStopAndAssigneeSelection = useCallback(
    (event, data) => {
      handleActiveIndex(data.activeIndex);
      // dispatch(selectStop(null));
      clearSelectedUser();
      dispatch(closeView());
    },
    [dispatch, clearSelectedUser]
  );

  useEffect(() => {
    handleActiveIndex(0);
  }, [hideLocationsTab]);

  return (
    <div className={styles.leftPanelContainer}>
      <div>
        <Tab
          style={{ height: '100%' }}
          menu={{ pointing: false }}
          panes={!hideLocationsTab ? panes : [panes[0]]}
          onTabChange={resetStopAndAssigneeSelection}
          activeIndex={activeIndex}
        />
      </div>
    </div>
  );
};

LeftPanelGrid.propTypes = {
  onUserSelect: PropTypes.func.isRequired,
  clearSelectedUser: PropTypes.func.isRequired,
  selectedUserIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  hideLocationsTab: PropTypes.bool.isRequired,
  selectedTaskTypeGroups: PropTypes.arrayOf(PropTypes.object),
  taskTypes: PropTypes.arrayOf(PropTypes.object),
};

export default LeftPanelGrid;
